module.exports = __webpack_public_path__ + "e3350bb7547c62061dc180c764492583.jpg";